import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '@components/loginModal/find/find.module.scss';
import LabelInput from '@components/labelInput';
import { birthDateValidator, genderFlagValidator, onlyNumber } from '@utils/validators/validators';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

export const BirthDate = () => {
  const refGenderFlag = useRef<HTMLInputElement | null>(null);

  const {
    watch,
    register,
    formState: { errors },
  } = useFormContext();

  const birthDate = watch('birthDate');
  const onChangeBirthDate = () => {
    if (birthDate.length == 6 && refGenderFlag.current !== null) {
      refGenderFlag.current.focus();
    }
  };

  return (
    <div className={cx('infoWrap')}>
      <LabelInput
        {...register('birthDate', { validate: (value: number) => birthDateValidator(value) })}
        type="text"
        className={cx('input', 'type2', { error: errors.birthDate })}
        placeholder="생년월일 6자리"
        onInput={onlyNumber}
        onChange={onChangeBirthDate}
        maxLength={6}
        autoComplete="off"
      />
      <span className={cx('hyphen')} />
      <LabelInput
        {...register('genderFlag', {
          validate: (value: number) => genderFlagValidator(value),
          onChange: (e) => (refGenderFlag.current = e),
        })}
        type="text"
        className={cx('input', 'type3', { error: errors.genderFlag })}
        placeholder="성별"
        onInput={onlyNumber}
        maxLength={1}
        autoComplete="off"
      />
      <span className={cx('hiddenArea')} />
    </div>
  );
};
